import React, {PureComponent} from 'react';
import DownloadApp from 'common/components/button/DownloadApp';
import './BottomDownload.scss';
import conf from 'common/js/conf';


/**
 * 底部无数据下载APP提示
 */
export default class BottomDownload extends PureComponent {
    render() {
        return(
            <div className="m-btm-download">
                <p className="tips">{this.props.tips || conf.tips.nomore}</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/components/bottom-download/BottomDownload.jsx